// extracted by mini-css-extract-plugin
export default {"draggableChip":"f1_ga"};